import React from 'react';
import './SectionHeaderAtom.scss';

export type SectionHeaderOrd = string | number;

export interface SectionHeaderAtomProps {
  ord: SectionHeaderOrd;
  icon?: string;
  title: string;
  description?: string;
  className?: string;
}

const SectionHeaderAtom: React.FC<SectionHeaderAtomProps> = ({
  ord,
  icon,
  title,
  description,
  className = '',
}) => {
  const isLetter = typeof ord === 'string';
  const ordVariant = isLetter ? 'letter' : 'number';

  const classes = [
    'marketplace-section-header',
    `marketplace-section-header--${ordVariant}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      <span
        className={`marketplace-section-header__ord marketplace-section-header__ord--${ordVariant}`}
        aria-hidden="true"
      >
        {ord}
      </span>
      <div className="marketplace-section-header__content">
        <h3 className="marketplace-section-header__title">
          {icon && (
            <i
              className={`pi ${icon} marketplace-section-header__icon`}
              aria-hidden="true"
            />
          )}
          <span className="marketplace-section-header__title-text">{title}</span>
        </h3>
        {description && (
          <p className="marketplace-section-header__description">{description}</p>
        )}
      </div>
    </div>
  );
};

SectionHeaderAtom.displayName = 'SectionHeaderAtom';

export default SectionHeaderAtom;
